module.exports = __webpack_public_path__ + "fe9ec8f28513855f8e4ef56242303b.png";